import config from './../config'

var url = function (alias) {
    switch (alias) {
        case 'EMAILS':
            return config.DEBUG ? config.emailsUrl : config.emailsUrlProd
        case 'EMAIL':
            return config.DEBUG ? config.emaildetailUrl : config.emaildetailUrlProd
        case 'RAW_DATA':
            return config.DEBUG ? config.rawData : config.rawDataProd
        case 'SEARCH':
            return config.DEBUG ? config.searchUrl : config.searchUrlProd
        case 'U_FLAG':
            return config.DEBUG ? config.updateFlag : config.updateFlagProd
        case 'U_PANELIST_SCORE':
            return config.DEBUG ? config.updatePanelistScore : config.updatePanelistScoreProd
        case 'U_STATUS':
            return config.DEBUG ? config.updateStatus : config.updateStatusProd
        case 'U_MARK':
            return config.DEBUG ? config.updateMark : config.updateMarkProd
        case 'JSON_HEADER':
            return config.headerJson
        case 'SCORE':
            return config.DEBUG ? config.score : config.scoreProd
        case 'COMPANY':
            return config.DEBUG ? config.getCompany : config.getCompanyProd
        case 'SPACEY':
            return config.DEBUG ? config.spaceyUrl : config.spaceyUrlProd
        case 'SPACEYEMAIL':
            return config.DEBUG ? config.spaceyEmail : config.spaceyEmailProd
        case 'API':
            return config.DEBUG ? config.baseUrlApi : config.baseUrlApiProduction
        case 'SPACEY2019':
            return config.DEBUG ? config.spacey2019Url : config.spacey2019UrlProd
        case 'COMPANY2019':
            return config.DEBUG ? config.getCompany2019 : config.getCompanyProd2019
        case 'VISUALIZE':
            return config.DEBUG ? config.VisualizeUrl : config.VisualizeUrlProd
        case 'IMPORT_JOB':
            return config.DEBUG ? config.importjoblogs : config.importjoblogsProd
        case 'EMAIL_BODY_HTML':
            return config.DEBUG ? config.emailbodypopupdata : config.emailbodypopupdataprod
        case 'EMAILDETAIL':
            return config.DEBUG ? config.emaildetailUrl : config.emaildetailUrlProd
        case 'FORWARDEDEMAIL':
            return config.DEBUG ? config.forwardemailUrl : config.forwardemailUrlProd
        case 'HTMLBODY':
            return config.DEBUG ? config.htmlbodyUrl : config.htmlbodyUrlProd
        case 'EMAILSAVE':
            return config.DEBUG ? config.emailsaveUrl : config.emailsaveUrlProd
        case 'DE_DUPLICATES':
            return config.DEBUG ? config.deduplicates_local : config.deduplicates
        case 'DE_DUPLICATE_SEARCH':
            return config.DEBUG ? config.deduplicates_local_search : config.deduplicate_search
        case 'STATES':
            return config.DEBUG ? config.states : config.states_prod
        case 'RENDER_HTML':
            return config.render_html
        case 'READ_EMAIL':
            return config.DEBUG ? config.read_email : config.read_email_prod
        case 'ASSIGN_COPY':
            return config.DEBUG ? config.assigncopy : config.assigncopy_prod
        case 'RENDER_COMPANY':
            return config.DEBUG ? config.render_company_local : config.render_company_prod
        case 'RENDER_PROCESSED_HTML':
            return config.render_processed_html
        case 'RENDER_PDF':
            return config.render_pdf
        case 'ALL_PREDICTIONS':
            return config.DEBUG ? config.all_prediction_url_local : config.all_prediction_url_prod
        case 'SECTORPRED_URL':
            return config.DEBUG ? config.sector_url_local : config.sector_url_prod
        case 'CATEGORYPRED_URL':
            return config.DEBUG ? config.category_url_local : config.category_url_prod
        case 'MAILINGTYPEPRED_URL':
            return config.DEBUG ? config.mailingtype_url_local : config.mailingtype_url_prod
        case 'SECCOMPANYPRED_URL':
            return config.DEBUG ? config.seccompany_url_local : config.seccompany_url_prod
        case 'SENDMAIL':
            return config.DEBUG ? config.sendmailURL_local : config.sendmailURL_prod
        case 'GETFORWARD_EMAIL':
            return config.DEBUG ? config.getForwardApiURL_local : config.getForwardApiURL_prod
        case 'GET_ATTACHMENTS':
            return config.DEBUG ? config.getAttachements_local : config.getAttachements_prod
        case 'DELETE_FWD_EMAILS':
            return config.DEBUG ? config.deleteemailapi_local : config.deleteemailapi_prod
        case 'DOWNLOAD_ATTACHMENTS':
            return config.DEBUG ? config.downloadapi_local : config.downloadapi_prod
        case 'UPLOAD_ATTACHMENTS':
            return config.DEBUG ? config.uploadattachment_local : config.uploadattachment_prod
        case 'HTML_PDF_SERVICE':
            return config.DEBUG ? config.html_pdf_service_local : config.html_pdf_service_prod
        case 'UPDATE_SCORE':
            return config.DEBUG ? config.updatescore_local : config.updatescore_prod
        case 'TINY_MCE_API':
            return config.tiny_mce_api_key
        case 'RENDER_APC_PROCESS':
            return config.render_apc_process
        case 'COMPANY_PRED':
            return config.companyPredProd
        case 'SEARCH_DEDUPLICATE':
            // return config.DEBUG ? config.searchDeduplicate : config.searchDeduplicate
            return config.DEBUG ? config.searchDeduplicate : config.searchDeduplicateProd
        case 'BASE_URL':
            return config.DEBUG ? config.baseUrl : config.baseUrlProd

        case 'UPLOAD_PRODUCT_PDF':
            return config.DEBUG ? config.uploadpdf : config.uploadpdf_prod

        case 'VIEW_PDF_IMAGES':
            return config.DEBUG ? config.product_images : config.product_images_prod

        case 'ROTATE_IMAGES':
            return config.DEBUG ? config.images_rotate : config.images_rotate_prod

        case 'TEMP_PRODUCT_LISTING':
            return config.DEBUG ? config.product_admin_listing : config.product_admin_listing

        case 'SIGNIN_URL':
            return config.DEBUG ? config.sign_in_url : config.sign_in_prod_url

        case 'ROLE_PERMISSION_URL':
            return config.DEBUG ? config.role_permission_url : config.role_permission_prod_url

        case 'DOMAIN_NAME':
            return config.DEBUG ? config.domain_name : config.domain_prod_name

        case 'SIGNOUT_URL':
            return config.DEBUG ? config.sign_out_url : config.sign_out_prod_url

        case 'AUTO_SIGNOUT_URL':
            return config.DEBUG ? config.auto_sign_out_url : config.auto_sign_out_prod_url

        case 'REFRESH_TOKEN_URL':
            return config.DEBUG ? config.refresh_token_url : config.refresh_token_prod_url

        case 'DIRECT_MAIL_PDF_URL':
            return config.DEBUG ? config.direct_mail_pdf : config.direct_mail_pdf_prod

        case 'DIRECT_MAIL_TEMP_GRIP':
            return config.DEBUG ? config.direct_mail_temp_grid : config.direct_mail_temp_grid_prod

        case 'ALLOWED_SECTORS_URL':
            return config.DEBUG ? config.allowed_sectors_url : config.allowed_sectors_prod_url
        case 'PRODUCT_V2_URL':
            return config.DEBUG ? config.baseUrlProductv2 : config.baseUrlProductv2Prod
        case 'SENDER_DETAILS':
            return config.DEBUG ? config.senderDetails : config.senderDetailsProd
        case 'VISUAL_ANNOTATION_URL':
            return config.DEBUG ? config.visual_annotation_url : config.visual_annotation_prod_url
        case 'ADMIN_FRONTEND_URL':
            return config.DEBUG ? config.admin_frontend_url : config.admin_frontend__prod_url
        case 'TEXT_EXTRACTION_URL':
            return config.DEBUG ? config.text_extraction_url : config.text_extraction_prod_url
        case 'UPLOAD_SERVICE_URL':
            return config.DEBUG ? config.upload_service_url : config.upload_service_url_prod
        case 'EMAIL_FILE_UPLOAD_ATTACHMENT':
            return config.DEBUG ? config.upload_file_attachment_url : config.upload_file_attachment_url_prod
        case 'PRODUCT_ADMIN_LOG':
            return config.DEBUG ? config.product_log_url : config.product_log_url_prod
        case 'RESAMPLE3':
            return config.DEBUG ? config.resample_url : config.resample_url_prod
        case 'DOWNLOAD_FILE':
            return config.DEBUG ? config.download_file_path : config.download_file_path_prod
        case 'SOFT_DELETE':
            return config.DEBUG ? config.soft_delete_url : config.soft_delete_url_prod
        case 'PRODUCT_ARCHIEVE_LINK':
            return config.DEBUG ? config.archeive_link : config.archeive_link_prod
        case 'GET_USERS':
            return config.DEBUG ? config.get_user : config.get_user_prod
        case 'SEND_EMAIL_URL':
            return config.DEBUG ? config.send_email : config.send_email_prod
        case 'HEADLINE_PRIDICT':
            return config.DEBUG ? 'not_availible' : config.product_headline_predict
        case 'PRODUCT_DETAILS_SUGGESTION':
            return config.DEBUG ? config.product_details_suggestion_url : config.product_details_suggestion_url_prod
        case 'DMTM_FILENAME':
                return config.DEBUG ? config.DMTM_filename : config.DMTM_filename
        case 'PRODUCT_RAWDATA':
            return config.DEBUG ? config.productRawData : config.productRawDataProd
        case 'PRODUCT_MAPPING_DATA':
            return config.DEBUG ? config.productMappingData : config.productMappingDataProd
        case 'PRODUCT_COMPANY':
            return config.DEBUG ? config.productCompany : config.productCompanyProd
        case 'PRODUCT_AFFINITY':
            return config.DEBUG ? config.productAffinity : config.productAffinityProd
        case 'PRODUCT_IMAGE':
            return config.DEBUG ? config.productImage : config.productImageProd
        case 'PRODUCT_SECTOR':
            return config.DEBUG ? config.productSector : config.productSectorProd
        case 'PRODUCT_PAYMENT_CARD':
            return config.DEBUG ? config.productPaymentCard : config.productPaymentCardProd
        case 'PRODUCT_MORTGAGE_LOAN':
            return config.DEBUG ? config.productMortgageLoan : config.productMortgageLoanProd
        case 'PRODUCT_PANELIST':
            return config.DEBUG ? config.productPanelist : config.productPanelistProd
        case 'PRODUCT_RETAIL':
            return config.DEBUG ? config.productRetail : config.productRetailProd
        case 'PRODUCT_LAST_WORKED_USER':
            return config.DEBUG ? config.productLastWorkedUser : config.productLastWorkedUserProd
        case 'PRODUCT_SECTORS_DATA':
            return config.DEBUG ? config.productSectorsData : config.productSectorsDataProd
        case 'PROCESSED_UPLOAD_PDF':
            return config.DEBUG ? config.processedUploadPdf : config.processedUploadPdfProd

        default:
            return false
    }
}

export default url